<template>
  <div class="row mb-2">
    <h5>Essa função adiciona Avaliadores para que possam avaliador o projeto em questão no dia da Mostra.</h5>
  </div>
  <div class="row">
    <div class="col-10">
      <form-group label="Avaliador" required>
        <select class="form-select" ref="select2"
                data-control="select2"
                v-select2 data-placeholder="Selecione uma opção">
          <option></option>
          <option v-for="avaliador in avaliadores" :value="avaliador.id" :key="avaliador.id">{{avaliador.name}} ({{avaliador.avaliadores_mesa.length}})</option>
        </select>
      </form-group>
    </div>
    <div class="col-2">
      <a href="#" @click="adicionar(); disposeTooltip()" v-if="can('ADM')"
         class="btn btn-icon btn-light-primary btn-sm border-0 mt-8"
         data-bs-toggle="tooltip"
         data-bs-trigger="hover"
         title="Adicionar">
        <i class="fs-2 bi bi-plus"></i>
      </a>
    </div>

    <div class="row">
      <div class="col-12 mt-5" v-if="avaliadoresMesa.length">
        <h6>Avaliadores da Mesa</h6>
        <span class="fs-5 d-block mt-2" v-for="avaliador in avaliadoresMesa">{{avaliador.name}} <a href="#" class="text-danger fs-6 text-decoration-underline ms-6" @click="remover(avaliador)">remover</a></span>
      </div>
    </div>
  </div>
</template>

<script>
import {useForm} from "@inertiajs/inertia-vue3";
import FormGroup from "@forms/FormGroup";
import FormBody from "@forms/FormBody";
import axios from "axios";
import {success} from "../../Settings/toastr";

export default {
  props: ['projeto', 'avaliadores'],

  components: {
    FormGroup,
    FormBody
  },
  data: _ => ({
    model: {
      projeto: null,
    },
    avaliadoresMesa: [
    ],
    errors: {
      novo_avaliador: false,
    },
    loading: false,
  }),

  created() {
    this.model.projeto = this.projeto.id

    this.emitter.on('adiciona-avaliadores-mesa', async function () {
      this.emitter.emit('loading-modal', true)
      await axios.post(this.route('app.avaliadores.json.adiciona_avaliadores_mesa'), {projeto_id: this.projeto.id, avaliadores: this.avaliadoresMesa}).then(result => {
        if (result.status === 201) {
          success('Avaliador(es) adicionado(s) ao projeto com sucesso!')
          // setTimeout( () => {
          //   window.location.reload()
          // }, 2000)

          this.emitter.emit('loading-modal', false)
          this.emitter.off('adiciona-avaliadores-mesa')
        }
      })
    }.bind(this))
  },

  mounted() {
    $(this.$refs.select2).select2({
      dropdownParent: '#appModal'
    })

    this.loadAvaliadoresMesas()
  },
  methods: {
    adicionar() {
      if(this.$refs.select2.value) {
        let has = this.avaliadoresMesa.find(item => parseInt(item.id) === parseInt(this.$refs.select2.value))

        if (has) {
          return
        }

        let name = this.$refs.select2.selectedOptions[0].innerText.split(' ', 3).join(' ')
        this.avaliadoresMesa.push({name: name, id: this.$refs.select2.value})
      }
    },
    async remover(avaliador) {
      let index = this.avaliadoresMesa.findIndex(item => item.id === avaliador.id)

      this.emitter.emit('loading-modal', true)

      if (this.avaliadoresMesa[index].created_at) {
        //Remover do banco
        await axios.post(this.route('app.avaliadores.json.remove_avaliadores_mesa'), {projeto_id: this.projeto.id, avaliador_id: this.avaliadoresMesa[index].id})
        success('Avaliador removido do projeto com sucesso!')
      }

      this.emitter.emit('loading-modal', false)

      this.avaliadoresMesa.splice(index, 1)
    },
    setAvaliadoresMesas(avaliadoresMesas) {
      Object.values(avaliadoresMesas).forEach(item => this.avaliadoresMesa.push({name: item.avaliador, created_at: item.created_at, id: item.Avaliador_ID}))
    },
    async loadAvaliadoresMesas() {
      this.emitter.emit('loading-modal', true)

      await axios.get(this.route('app.avaliadores.json.avaliadores_mesas', {projetoId: this.projeto.id})).then(response => {
        this.setAvaliadoresMesas(response.data)
      })

      this.emitter.emit('loading-modal', false)
    }
  },
}
</script>
